import React, { useState, useEffect } from "react";
import { StatusCard } from "@hopper/status_card";
import { useHistory } from "react-router-dom";
import { StatusBarProps } from "@hopper/status_bar";

export type AlertAutoDismissableProps = {
  alertKey: string;
  type?: StatusBarProps["color"];
  message?: string | JSX.Element;
  dismissAlert: (alertKey: string) => void;
  delay?: number;
};

const AlertAutoDismissable = ({ alertKey, type, message, dismissAlert, delay = 8000 }: AlertAutoDismissableProps) => {
  const [showAlert, setShowAlert] = useState(true);
  const history = useHistory();
  let timeout: NodeJS.Timeout;

  useEffect(() => {
    const unlisten = history.listen(() => {
      handleAlertDismiss();
    });

    setAutoDismissTimeout();

    return () => {
      clearTimeout(timeout);
      unlisten();
    };
  }, []);

  const setAutoDismissTimeout = () => {
    if (delay > 0) {
      timeout = setTimeout(() => {
        setShowAlert(false);
        handleAlertDismiss();
      }, delay);
    }
  };

  const handleAlertDismiss = () => {
    dismissAlert(alertKey);
  };

  return showAlert ? (
    <div className="my-xl">
      <StatusCard elevation={1} isRounded={false} statusColor={type} statusPosition="left" statusSize="md">
        {message}
      </StatusCard>
    </div>
  ) : null;
};

export default AlertAutoDismissable;
